import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-auth-signup-form',
  templateUrl: './auth-signup-form.component.html',
  styleUrls: ['./auth-signup-form.component.scss'],
})
export class AuthSignupFormComponent {
  auth_signup_form_group: FormGroup = this.form_service.auth_signup_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_password_visible: boolean = false;

  constructor(
    private form_service: FormService,
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
  ) {}

  onSignupClick(): void {
    this.navigation_service.toAgentBuilder();
  }

  onSigninRedirectClick(): void {
    this.navigation_service.toAuthSignin();
  }

  hasPssLengthError(confirm: boolean): boolean | undefined {
    return this.utils_service.hasPssLengthError(
      this.auth_signup_form_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }

  hasPssPatternError(confirm: boolean): boolean | undefined {
    return this.utils_service.hasPssPatternError(
      this.auth_signup_form_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }

  getPssFormFieldErrorClass(confirm: boolean): {
    [key: string]: boolean | undefined;
  } {
    return this.utils_service.getPssFormFieldErrorClass(
      this.auth_signup_form_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }
}
